import axios from 'axios'
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  try {
    if (error.response.status && error.response.status === 401) {
      sessionStorage.setItem('login', false)
      window.location.reload()
    }
  } catch (err) {
    // console.log('No response error in axios interceptor')
  }
})
export default axios
